//JUDGEME
(() => {
  const judgmeWatcher = setInterval(() => {
    const elements = Array.from(document.querySelectorAll('.jdgm-random-link.jdgm-hidden'));
    if (elements.length > 0) {
      elements.forEach((el) => {
        el.title = 'Link for decorational purposes only';
        el.ariaLabel = 'Link for decorational purposes only';
      });
      clearInterval(judgmeWatcher);
    }
    const badgets = Array.from(document.querySelectorAll('.jdgm-verified-count-badget'));
    if (badgets.length > 0) {
      badgets.forEach((el) => {
        el.title = el.innerText;
        el.ariaLabel = el.innerText;
      });
      clearInterval(judgmeWatcher);
    }
  }, 500);
})();

// EMPTY HEADINGS
(() => {
  Array.from(document.querySelectorAll('h1,h2,h3,h4,h5,h6')).forEach((heading) => {
    if (heading.children.length === 0 && heading.textContent.length === 0) {
      heading.remove();
    }
  });
})();

// IFRAMES
(() => {
  const iframeTitleMap = [
    { pattern: /trustpilot/i, title: 'Trustpilot rating widget' },
    { pattern: /trustedsite|mcafeesecure/i, title: 'TrustedSite certified secure badge' },
    { pattern: /shopperapproved/i, title: 'Shopper Approved reviews widget' },
    { pattern: /hotjar/i, title: 'Hotjar analytics' },
    { pattern: /googletagmanager|gtm/i, title: 'Google Tag Manager' },
    { pattern: /youtube|youtu\.be/i, title: 'YouTube video player' },
    { pattern: /vimeo/i, title: 'Vimeo video player' },
    { pattern: /zip\.co|quadpay|sezzle|afterpay|klarna/i, title: 'Buy now pay later widget' },
  ];

  window.addEventListener('load', () => {
    Array.from(document.querySelectorAll('iframe')).forEach((iframe) => {
      if (!iframe.title) {
        const src = iframe.src || iframe.getAttribute('data-src') || '';
        const match = iframeTitleMap.find(({ pattern }) => pattern.test(src));
        iframe.title = match ? match.title : 'Embedded content';
      }
    });
  });
})();

// TRUSTED SITE BACKUP
window.addEventListener('load', () => {
  Array.from(document.querySelectorAll('.trustedsite-trustmark')).forEach((trustmark) => {
    if (!trustmark.classList.contains('loaded')) {
      trustmark.innerHTML = `<img class="pdp__awards__award-container__img" src="${window.TRUSTED_SITE_FALLBACK}" alt="trustedsite secure badge" style="width: 100%; mix-blend-mode: multiply;" />`;
    }
  });
});
